import * as z from "zod/mini";

export const offerTypeSchema = z.optional(z.enum(["select", "existing"]));

export const directOfferSearchSchema = z.object({ offerType: offerTypeSchema });

export type OfferType = NonNullable<z.infer<typeof offerTypeSchema>>;
